export const HOMEPAGE_ROUTE = '/';
export const ROUTE_SIGN_UP = '/signup/';
export const ROUTE_SIGN_UP_INTRO = '/signup/intro/';
export const MY_HUNGRYROOT_ROUTE = '/myhungryroot/';
export const MY_HUNGRYROOT_ORDERS_ROUTE = `${MY_HUNGRYROOT_ROUTE}?orders=true`;
export const EDIT_DELIVERY_RECIPES_ROUTE = '/edit-delivery/recipes/';
export const EDIT_DELIVERY_GROCERIES_ROUTE = '/edit-delivery/groceries/';
export const PLAN_ROUTE = '/plan/';
export const LOGIN_ROUTE = '/login/';
export const WALLET_ROUTE = '/wallet/';
export const REWARDS_ROUTE = '/rewards/';
export const CYO_ROUTE = '/limited-time/';
export const CHECKOUT_CONGRATS_ROUTE = '/checkout/congrats/';
export const CHECKOUT_SHIPPING_ROUTE = '/checkout/shipping/';
export const CHECKOUT_V2_SHIPPING_ROUTE = '/checkout/shipping-v2/';
export const CHECKOUT_V2_PAYMENT_ROUTE = '/checkout/payment-v2/';
export const CHECKOUT_PAYMENT_ROUTE = '/checkout/payment/';
export const REACTIVATE_ROUTE = '/account/reactivated/';
export const ORDER_ROUTE = '/order/';
export const ORDER_DETAILS_ROUTE = '/order/:orderId/';
export const ORDERS_ROUTE = '/orders/';
export const SUPPORT_ARTICLE_ROUTE = '/support-articles/';
export const SUPPORT_ARTICLE_QUICK_TOUR_ROUTE = '/support-articles/quick-tour/';
export const SUPPORT_ARTICLE_SHOP_WITH_CREDITS_ROUTE =
  '/support-articles/shop-with-credits/';
export const SUPPORT_ARTICLE_FIRST_DELIVERY_ROUTE =
  '/support-articles/first-delivery/';
export const SUPPORT_ARTICLE_FOOD_PROFILE_ROUTE =
  '/support-articles/food-profile/';
export const SUPPORT_ARTICLE_SCHEDULE_MANAGEMENT_ROUTE =
  '/support-articles/schedule-management/';
export const SUPPORT_ARTICLE_DELIVERY_ISSUES_ROUTE =
  '/support-articles/delivery-issues/';
export const SUPPORT_ARTICLE_EDIT_ORDER_ROUTE = '/support-articles/edit-order/';
export const SUPPORT_ARTICLE_EDIT_PLAN_ROUTE = '/support-articles/edit-plan/';

export const ACCOUNT_HISTORY_ROUTE = '/account/history/';
export const ACCOUNT_SETTINGS_ROUTE = '/account/settings/';
/**
 * Guest-namespaced account settings (email + password) for a signed-in,
 * not-yet-checked-out customer. `ACCOUNT_SETTINGS_ROUTE` lives inside the
 * checked-out MyHungryroot SPA, which `RequireCheckedOut` never renders for a
 * guest; this sibling follows the `/guest/` namespace the guest cookbook and
 * dietary preferences already use so the checked-out page stays untouched.
 * Unlike those Exp 255 surfaces it is not experiment-gated: every guest can
 * manage their credentials, including the iOS app's guest WebView.
 */
export const GUEST_ACCOUNT_SETTINGS_ROUTE = '/guest/account/settings/';
export const ACCOUNT_PREFERENCES_ROUTE = '/preferences/';
export const ACCOUNT_HELP_CENTER_ROUTE = '/faq/';
export const ACCOUNT_ORDER_HISTORY_ROUTE = '/account/history/';
export const ACCOUNT_REFERRAL_ROUTE = '/account/referral/';

// Scannable entry points
export const BROWSE_GROCERIES_ROUTE = '/browse/groceries/';
// Experiment 242; Browse Cookbooks
export const BROWSE_COOKBOOKS_ROUTE = '/browse/cookbooks/';
// Authenticated cookbook detail view (SPA). Checked-out customers are routed
// here from the public `/cookbook/:slug` page so they get the in-app shell
// (cart, modals, nav). `:slug` is the curated cookbook slug.
export const BROWSE_COOKBOOK_DETAIL_ROUTE = `${BROWSE_COOKBOOKS_ROUTE}:slug/`;
// Authenticated community (user-generated) cookbook detail view (SPA). Mirrors
// the marketing detail route above: checked-out customers are routed here from
// the public `/community/cookbook/:slug` page for the in-app shell. Plural
// `cookbooks` matches the marketing authenticated convention.
export const BROWSE_COMMUNITY_COOKBOOKS_ROUTE = '/browse/community/cookbooks/';
export const BROWSE_COMMUNITY_COOKBOOK_DETAIL_ROUTE = `${BROWSE_COMMUNITY_COOKBOOKS_ROUTE}:slug/`;
// Experiment 242; Browse Meals surface
export const BROWSE_MEALS_ROUTE = '/browse/meals/';
// Experiment 242; Browse surface (popsicle)
export const BROWSE_ROUTE = '/browse/';

export const MY_COOKBOOK_ROUTE = '/mycookbook/';
// Experiment 252; one of the customer's own cookbooks. Keyed by numeric id
// because the customer cookbook API is pk-addressed
// (`/api/v3/customers/{id}/cookbooks/{pk}/`), unlike the public cookbook
// routes above, which are slug-based and CDN-cached.
export const MY_COOKBOOK_DETAIL_ROUTE = `${MY_COOKBOOK_ROUTE}:cookbookId/`;
/**
 * Experiment 252; the default ("{Name}’s Saves") cookbook, which occupies the
 * `:cookbookId` slot with a sentinel rather than a number.
 *
 * It has no addressable pk to route by — the backend synthesizes it from the
 * favorites tables and only mints a row once the customer shares it — and the
 * pk-addressed endpoint above rejects it regardless, because it serves only
 * USER-type cookbooks. Its own read lives at
 * `/api/v3/customers/self/cookbooks/favorites/`, so the segment mirrors that.
 * Unambiguous against the numeric ids it shares the slot with.
 */
export const MY_COOKBOOK_FAVORITES_SEGMENT = 'favorites';
export const MY_COOKBOOK_FAVORITES_ROUTE = `${MY_COOKBOOK_ROUTE}${MY_COOKBOOK_FAVORITES_SEGMENT}/`;
/**
 * Experiment 255 (freemium): prospects and guests get their own cookbook routes
 * rather than sharing `/mycookbook/` with the checked-out SPA, so the customer
 * route stays untouched. The namespace is provisional and may change.
 */
export const START_MY_COOKBOOK_ROUTE = '/start-mycookbook/';
export const GUEST_MY_COOKBOOK_ROUTE = '/guest/mycookbook/';
/**
 * Guest cookbook sub-routes mirror the checked-out SPA's structure so the guest
 * experience is 1:1 with `/mycookbook/`: an index at the base, the favorites
 * cookbook, and per-cookbook detail. Detail is ordered before the index at the
 * router because the base route isn't `exact` and would otherwise swallow it —
 * same ordering as `MY_COOKBOOK_DETAIL_ROUTE`.
 */
export const GUEST_MY_COOKBOOK_FAVORITES_ROUTE = `${GUEST_MY_COOKBOOK_ROUTE}${MY_COOKBOOK_FAVORITES_SEGMENT}/`;
export const GUEST_MY_COOKBOOK_DETAIL_ROUTE = `${GUEST_MY_COOKBOOK_ROUTE}:cookbookId/`;
export const ORDERS_PLACEHOLDER_ROUTE = '/orders/';
/**
 * Exp 255 (freemium) marketing page — the guest "Orders" tab. Gated
 * client-side to enrolled guests; a customer redirects to `/orders/` and
 * everyone else (prospect, not enrolled, desktop) to `/discover/`.
 */
export const START_ORDER_ROUTE = '/start-order/';

export const GIFT_ROUTE = '/gift/';
export const GIFT_SUBMIT_CLAIM_CODE_ROUTE = '/gift/submit/claim_code/';
export const COMMUNITY_URL = 'https://www.facebook.com/groups/hungryroot';
export const EDIT_DELIVERY_RECIPES_FOR_YOU_ROUTE =
  '/edit-delivery/recipes/for-you/';
export const EDIT_DELIVERY_GROCERIES_FOR_YOU_ROUTE =
  '/edit-delivery/groceries/for-you/';

export const CA_EMPLOYEE_PRIVACY_POLICY_ROUTE = '/privacy/ca-employee-notice/';
export const PRIVACY_ROUTE = '/privacy/';
export const REVIEWS_ROUTE = '/reviews/';
export const LEADERSHIP_ROUTE = '/leadership/';
export const PHILOSOPHY_ROUTE = '/philosophy/';
export const PACKAGING_ROUTE = '/packaging/';
export const TERMS_ROUTE = '/terms/';
export const ACCESSIBILITY_ROUTE = '/accessibility/';
export const CAREERS_ROUTE = '/careers/';
export const UPCOMING_ORDERS_ROUTE = '/upcoming';

export const WELCOME_ROUTE = '/welcome/';
export const ATTRIBUTION_SURVEY_ROUTE = '/attribution-survey/';
export const FOOD_PROFILE_ROUTE = '/food-profile/';
export const FOOD_PROFILE_IMPROVE_SMARTCART_ROUTE =
  '/food-profile/improve-my-smartcart/';
export const FOOD_PROFILE_DIETARY_PREFERENCES_ROUTE =
  '/food-profile/dietary-preferences/';
/**
 * Exp 255 (freemium) guest-namespaced dietary preferences, linked from the guest
 * profile overlay. Mirrors the `/guest/` namespace used by the guest cookbook so
 * the guest experience stays parallel to the checked-out
 * `FOOD_PROFILE_DIETARY_PREFERENCES_ROUTE`. Currently a placeholder shell; the
 * dietary-preferences UI (today rendered inside the auth-gated MyHungryroot SPA)
 * is exposed to guests in a follow-up.
 */
export const GUEST_FOOD_PROFILE_DIETARY_PREFERENCES_ROUTE =
  '/guest/food-profile/dietary-preferences/';
export const FOOD_PROFILE_NEVERS_ROUTE = '/food-profile/nevers/';
/** Exp 195 variant 12 ingredient Dislikes list (not tag Nevers). */
export const FOOD_PROFILE_INGREDIENT_DISLIKES_ROUTE =
  '/food-profile/ingredient-dislikes/';
export const FOOD_PROFILE_NEVERS_DEEP_LINK = 'food-profile-nevers';
export const ACCOUNT_PREFERENCES_NEVERS_ROUTE = `${ACCOUNT_PREFERENCES_ROUTE}#${FOOD_PROFILE_NEVERS_DEEP_LINK}`;

export const CANCEL_FIRST_ORDER_ROUTE = '/cancel/first-order/';
/** Legacy `pages-cancel` / Springroll flow entry */
export const CANCEL_LEGACY_FLOW_ROUTE = '/cancel/';

/** Experiment 235 — pause/hold offer presented before reason selection */
export const CANCELLATION_PAUSE_ROUTE = '/cancellation/pause/';
/** Experiment 235 — primary cancellation reason step */
export const CANCELLATION_PRIMARY_REASON_ROUTE = '/cancellation/reason/';
/** Secondary / follow-up cancellation reason step */
export const CANCELLATION_SECONDARY_REASON_ROUTE = '/cancellation/details/';
/** Deflection content before completing cancel flow */
export const CANCELLATION_DEFLECTION_ROUTE = '/cancellation/review/';
/** Final feedback step before account cancel (Exp 235) */
export const CANCELLATION_CONFIRM_ROUTE = '/cancellation/confirm/';
/** Winback promo offer before continuing to cancel (Exp 235) */
export const CANCELLATION_SPECIAL_OFFER_ROUTE = '/cancellation/special-offer/';

export { isEqualPathnames } from './isEqualPathnames';
export { isEqualToAtLeastOnePathname } from './isEqualToAtLeastOnePathname';

export const SMART_CART_AGENT_CHAT_ROUTE = '/smartcart-agent/';

export const PRECHECKOUT_PLAN_ROUTE = '/survey/plan/';

export const generateDynamicAccountOrdersRoute = ({
  orderId,
}: {
  orderId: number | string;
}) => `/account/orders/${orderId}/`;

export const generateOrderDetailRoute = ({
  orderId,
}: {
  orderId: number | string;
}) => `/order/${orderId}/`;

export const DELIVERY_HELP_ROUTE = '/delivery-help/';
export const DELIVERY_HELP_DETAILS_ROUTE = '/delivery-help/:orderId/';

export const generateDeliveryHelpRoute = ({
  orderId,
}: {
  orderId: number | string;
}) => `/delivery-help/${orderId}/`;

// Quiz routes
export const ROUTE_QUIZ_INTRO = '/quiz/intro/';
export const ROUTE_QUIZ_BUDGET = '/quiz/budget/';
export const ROUTE_QUIZ_BUDGET_BENEFITS = '/quiz/budget-benefits/';
export const ROUTE_QUIZ_HEALTH_GOALS = '/quiz/health-goals/';
export const ROUTE_QUIZ_HELLO = '/quiz/hello/';
export const ROUTE_QUIZ_GOALS = '/quiz/hello/goals/';
export const ROUTE_QUIZ_GOALS_BENEFITS = '/quiz/goals-benefits/';
export const ROUTE_QUIZ_EATING_HABITS = '/quiz/eating-habits/';
export const ROUTE_QUIZ_EATING_HABITS_DIETARY_NEEDS =
  '/quiz/eating-habits/dietary-needs/';
export const ROUTE_QUIZ_MACRO_NUTRIENT = '/quiz/macro-nutrient/';
export const ROUTE_QUIZ_MACRO_NUTRIENT_LOW_SODIUM =
  '/quiz/macro-nutrient/low-sodium/';
export const ROUTE_QUIZ_FOOD_QUALITIES = '/quiz/food-qualities/';
export const ROUTE_QUIZ_FOOD_FORMATS = '/quiz/food-formats/';
export const ROUTE_QUIZ_CUISINES = '/quiz/cuisines/';
export const ROUTE_QUIZ_FLAVORS = '/quiz/flavors/';
export const ROUTE_QUIZ_PROTEIN = '/quiz/protein/';
export const ROUTE_QUIZ_PROTEIN_PREFERENCES = '/quiz/protein-preferences/';
export const ROUTE_QUIZ_AVOIDANCES = '/quiz/avoidances/';
export const ROUTE_QUIZ_POLARIZING = '/quiz/polarizing/';
export const ROUTE_QUIZ_FOOD_PREFERENCES_INTRO =
  '/quiz/food-preferences-intro/';
export const ROUTE_QUIZ_BREAKFAST = '/quiz/breakfast/';
export const ROUTE_QUIZ_READY_MADE = '/quiz/ready-made/';
export const ROUTE_QUIZ_SNACKS = '/quiz/snacks/';
export const ROUTE_QUIZ_SWEETS = '/quiz/sweets/';
export const ROUTE_QUIZ_LUNCH = '/quiz/lunch/';
export const ROUTE_QUIZ_DINNER = '/quiz/dinner/';
export const ROUTE_QUIZ_SWIPE = '/quiz/swipe/';
export const ROUTE_QUIZ_MEAL_FREQUENCIES = '/quiz/meal-frequencies/';
export const ROUTE_QUIZ_BUILDING = '/quiz/building/';
export const ROUTE_QUIZ_DISH_TYPES = '/quiz/dish-types/';

// Mini-quiz routes (Exp 255). Parallel to ROUTE_QUIZ_* — never add these
// to ROUTE_SEQUENCES / allQuizRoutes / funnelRoutesSchema.
export const ROUTE_MINI_QUIZ_INDEX = '/mini-quiz/';
export const ROUTE_MINI_QUIZ_FOOD_FORMATS = '/mini-quiz/food-formats/';
export const ROUTE_MINI_QUIZ_EATING_HABITS = '/mini-quiz/eating-habits/';
export const ROUTE_MINI_QUIZ_MACRO_NUTRIENT = '/mini-quiz/macro-nutrient/';
export const ROUTE_MINI_QUIZ_MACRO_NUTRIENT_LOW_SODIUM =
  '/mini-quiz/macro-nutrient/low-sodium/';
export const ROUTE_MINI_QUIZ_DISH_TYPES = '/mini-quiz/dish-types/';
export const ROUTE_MINI_QUIZ_CUISINES = '/mini-quiz/cuisines/';
export const ROUTE_MINI_QUIZ_PROTEIN = '/mini-quiz/protein/';
export const ROUTE_MINI_QUIZ_AVOIDANCES = '/mini-quiz/avoidances/';
export const ROUTE_MINI_QUIZ_LOADING = '/mini-quiz/loading/';
export const ROUTE_MINI_QUIZ_FOOD_PREFERENCES_INTRO =
  '/mini-quiz/food-preferences-intro/';
export const ROUTE_MINI_QUIZ_SIGNUP = '/mini-quiz/signup/';
export const ROUTE_MINI_QUIZ_HELLO = '/mini-quiz/hello/';
export const ROUTE_MINI_QUIZ_SWIPE = '/mini-quiz/swipe/';
export const ROUTE_MINI_QUIZ_TERMINAL = '/mini-quiz/terminal/';
export const ROUTE_MINI_QUIZ_MEAL_FREQUENCIES = '/mini-quiz/meal-frequencies/';
export const ROUTE_MINI_QUIZ_BUDGET = '/mini-quiz/budget/';
export const ROUTE_MINI_QUIZ_BUDGET_BENEFITS = '/mini-quiz/budget-benefits/';

// pre-auth catalog routes
export const PRE_AUTH_CATALOG_RECIPES_ROUTE = '/catalog/recipes/';
export const PRE_AUTH_CATALOG_GROCERIES_ROUTE = '/catalog/groceries/';
export const PRE_AUTH_CATALOG_MEALS_ROUTE =
  '/catalog/groceries/?is_ready_to_eat=1';

/**
 * Query param appended to a catalog list redirect when a recipe or product
 * detail page can't be shown (the item is missing or no longer active). The
 * landing catalog page reads it to surface an "item not found" toast, then
 * strips it from the URL. The value names which kind of item was missing so
 * the toast copy can be specific.
 */
export const CATALOG_ITEM_NOT_FOUND_PARAM = 'not_found';
export const CATALOG_ITEM_NOT_FOUND_RECIPE = 'recipe';
export const CATALOG_ITEM_NOT_FOUND_PRODUCT = 'product';
export const ONBOARDING_WELCOME_ROUTE = '/onboarding/welcome/';
export const ONBOARDING_IMPROVE_SELECTIONS_ROUTE =
  '/onboarding/improve-selections/';

// Discover Cookbooks
export const DISCOVER_ROUTE = '/discover/';
// Exp 255 freemium feed for prospects/guests. Gated client-side to
// enrolled prospect/guest on mobile; everyone else redirects to DISCOVER_ROUTE.
export const DISCOVER_FEED_ROUTE = '/discover/feed/';
export const DISCOVER_RECIPES_ROUTE = '/discover/recipes/';
// Exp 255 variant surface: the pre-checkout mirror of BROWSE_MEALS_ROUTE.
// Checked-out customers are redirected there client-side.
export const DISCOVER_MEALS_ROUTE = '/discover/meals/';
// Exp 255 variant surfaces: the pre-checkout mirrors of BROWSE_GROCERIES_ROUTE
// (category tiles) and EDIT_DELIVERY_GROCERIES_ROUTE (filtered product grid).
// Checked-out customers are redirected to the originals client-side.
export const DISCOVER_BROWSE_GROCERIES_ROUTE = '/discover/browse-groceries/';
export const DISCOVER_GROCERIES_ROUTE = '/discover/groceries/';
export const DISCOVER_COOKBOOKS_ROUTE = '/discover/cookbooks/';
export const COOKBOOK_ROUTE = '/cookbook/:slug/';
// One-off landing page a set of paid ads points at. `:slug` is the
// CookbookLandingPage's own globally unique slug, not the cookbook's — one
// cookbook can back several of these with different creative. Nested under
// `/cookbook/` rather than given its own prefix so the two surfaces read as
// related; the extra segment keeps it clear of COOKBOOK_ROUTE.
export const COOKBOOK_LANDING_PAGE_ROUTE = '/cookbook/welcome/:slug/';
// Public community (user-generated favorites) cookbook detail page. Curated
// cookbooks stay on COOKBOOK_ROUTE; published favorites cookbooks live here.
export const COMMUNITY_COOKBOOK_ROUTE = '/community/cookbook/:slug/';
export const HOW_IT_WORKS_ROUTE = '/how-it-works/';
export const QUESTIONS_ROUTE = '/questions/';
